export const transformData = (data) => data.reduce((previousValue, currentValue) => {
  previousValue[currentValue.id] = {
    ...currentValue,
  };

  if (currentValue.children && currentValue.children.length > 0) {
    previousValue[currentValue.id].children = currentValue.children.map((item) => item.id);
    previousValue = { ...previousValue, ...transformData(currentValue.children) };
  }

  return previousValue;
}, {});

export const getTransformedData = (data) => {
  const items = transformData(data);

  items.root = {
    id: 'root',
    children: data.map((item) => item.id),
    hasChildren: true,
    isExpanded: true,
    isChildrenLoading: false,
    data: {
      title: 'root',
    },
  };

  return {
    rootId: 'root',
    items,
  };
};

export const getTransformedRowData = (data) => {
  const toSkip = [];

  const transformRows = (nestedData, isNested) => Object.keys(nestedData.items).reduce((previousValue, currentValue) => {
    if (toSkip.includes(currentValue) && !isNested) return previousValue;

    let newObject = {
      ...data.items[currentValue],
    };

    if (newObject.children && newObject.children.length > 0) {
      const childrenObj = {};

      newObject.children.forEach((child) => {
        toSkip.push(child);

        childrenObj[child] = {
          ...data.items[child],
        };
      });

      const children = {
        items: childrenObj,
      };

      newObject = { ...newObject, children: transformRows(children, true) };
    }

    previousValue.push(newObject);

    return previousValue;
  }, []);

  return transformRows(data);
};
